<template>
  <div class="pc-ask_answer">
    <template v-for="(item,index) in chatList" >
        <chat-room
        :key="item.id"
        :chatData="item.chatRecord"
        :Prompt="item.prompt"
        :RoomIdx="index"
        v-show="item.id===roomId"
        :Rid="item.id"
        :isNot="item.isNot"
        @setIsNot="setIsNot"
        :messageArr="item.messageArr"
        :textList="textList"
        :serIp="serIp"
        :chatModel="item.chatModel??'3.5'"
        />
    </template>
    <el-dialog width="550px" :show-close="false" :close-on-click-modal="false" center :visible.sync="bindShow" class="bind" @close="bindClosed">
      <div slot="title" class="dialog_title">
        <div>VIP升级成功</div>
        <!-- <span v-if="closeTime!==0">{{ closeTime }}秒后可关闭</span> -->
        <!-- <i class="el-icon-close" v-else @click="bindBeforeClosed"></i> -->
        <svg viewBox="0 0 100 100" class="svg" v-if="closeTime!==0">
          <circle cx="50" cy="50" r="40" fill="none" stroke-width="10" stroke="#efefef" class="cirle_bck"></circle>
          <circle cx="50" cy="50" r="40" fill="none" class="countdown"></circle>
          <text class="text" x="50" y="50" font-size="30" fill="#555" text-anchor="middle" dominant-baseline="middle" writing-mode="tb">{{ closeTime }}</text>
        </svg>
        <div class="close_icon" v-else>
          <i class="el-icon-close"  @click="bindBeforeClosed"></i>
        </div>
      </div>
      <div class="bind_tip">
        <span style="color:#f3a76b">为保障您的权益，</span>
        请绑定手机号或邮箱。绑定手机或邮箱后，以后可以使用手机号或邮箱登录、找回账号和密码。
      </div>
      <div class="bind_title">
        <input type="radio" v-model="activeIndex" :value="0" id="mobile" name="bind"  style="display: none;"/>
        <div class="select"></div>
        <label for="mobile">手机号</label>
        <input type="radio" v-model="activeIndex" :value="1" id="email" name="bind" style="display: none;"/>
        <div class="select"></div>
        <label for="email">邮箱</label>
      </div>
      <transition name="fade" mode="out-in">
        <div class="bindbox" key="mobile" v-if="activeIndex==0">
          <div class="input">
            <input type="text" :value="mobileForm.mobile" aria-autocomplete="none" @input="validMobile" :maxlength="50" placeholder="请输入手机号">
            <button @click="sendCode" :disabled="mobileForm.isWait" :class="!mobileForm.isWait?'click':'disabled'">{{mobileForm.codeText}}</button>
          </div>
          <!-- <el-input v-model="bindForm.mobile" @input="validMobile" type="text" maxlength="11" placeholder="请输入手机号"></el-input> -->
          <span>{{ mobileForm.mobileValid }}</span>
          <div class="code">
            <el-input v-model="mobileForm.code" type="text" maxlength="6" placeholder="请输入验证码" @input="mobileForm.codeValid=''"></el-input>
            <el-button type="primary" @click="confirmBind" style="padding:">立即绑定</el-button>
          </div>
          <span>{{ mobileForm.codeValid }}</span>
        </div>
        <div class="bindbox" key="email" v-else>
          <div class="input">
            <input type="text" :value="emailForm.email" aria-autocomplete="none" @input="validMobile" :maxlength="30" placeholder="请输入邮箱">
            <button @click="sendCode" :disabled="emailForm.isWait" :class="!emailForm.isWait?'click':'disabled'">{{emailForm.codeText}}</button>
          </div>
          <span>{{ emailForm.emailValid }}</span>
          <div class="code">
            <el-input v-model="emailForm.code" type="text" maxlength="6" placeholder="请输入验证码" @input="emailForm.codeValid=''"></el-input>
            <el-button type="primary" @click="confirmBind" style="padding:">立即绑定</el-button>
          </div>
          <span>{{ emailForm.codeValid }}</span>
        </div>
      </transition>
    </el-dialog>
    <el-dialog :show-close="false" center :visible.sync="tipShow" width="360px" top="25vh" :close-on-click-modal="false">
      <div class="tip">
        <span>手机号绑定成功!</span>
        <div class="btn">
          <el-button size="small" @click="tipShow=false;bindShow=false">下次再说</el-button>
          <el-button type="primary" size="small" @click="tipConfirm">去绑定邮箱</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :show-close="false" center :visible.sync="confirmShow" width="450px" top="25vh" :close-on-click-modal="false">
      <div class="tip">
        <span>您方便的时候仍然可以在<span style="color: #0084ff;">用户中心</span>绑定手机号或邮箱。</span>
        <div class="btn">
          <el-button type="primary" size="small" @click="bindShow=false;confirmShow=false">我已知晓</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { chatHelpPrompts, chatHelpIp } from '@/api/ask_answer'
import { chatCaptchaCode } from '@/api/login'
import { chatUserUpdateInfo } from '@/api/user_center'
export default {
  name: 'PCAskAnswer',
  components: {
    chatRoom: () => import('@/components/chatRoom/chatRoom.vue')
  },
  computed: {
    ...mapState(['roomId', 'AllchatRecord', 'userInfo'])
  },
  data () {
    return {
      chatList: this.$store.state.AllchatRecord,
      textList: [
        {
          txt: '给我写一个x手机产品的文案',
          type: 'click'
        },
        {
          txt: '能记住对话过程中，前面提过的内容'
        },
        {
          txt: '回答中偶尔会有事实性错误'
        },
        {
          txt: '帮我写一篇科幻类文章的大纲',
          type: 'click'
        },
        {
          txt: '支持用户提供后续更正'
        },
        {
          txt: '可能会出现有偏见或歧视性回答'
        },
        {
          txt: '我最近心情不好怎么办',
          type: 'click'
        },
        {
          txt: '懂得拒绝不合理的提问'
        },
        {
          txt: '对2021年以后的事了解有局限'
        }
      ],
      serIp: '',
      // 跳转行为
      action: this.$route.query.action,
      // 绑定手机号表单
      mobileForm: {
        mobile: '',
        mobileValid: '',
        code: '',
        codeText: '发送验证码',
        codeValid: '',
        isWait: false
      },
      emailForm: {
        email: '',
        emailValid: '',
        code: '',
        codeText: '发送验证码',
        codeValid: '',
        isWait: false
      },
      bindShow: false,
      tipShow: false,
      confirmShow: false,
      // 绑定类型 0手机 1邮箱
      activeIndex: 0,
      closeTime: 60
    }
  },
  created () {
    // 获取推荐聊天内容
    this.getRecommendMsg()
    // 获取IP
    if (!this.serIp) {
      this.getServierIp()
    }
  },
  methods: {
    // 设置当前是否显示信息提示
    setIsNot ({ bol, index }) {
      const arr = this.AllchatRecord
      arr[index].isNot = bol
      this.$store.commit('setAllchatRecord', arr)
    },
    // 获取推荐聊天内容
    async getRecommendMsg () {
      const { data: { prompts } } = await chatHelpPrompts()
      this.textList.forEach((item, index) => {
        if (index + 1 === 1) {
          this.textList[index].txt = prompts[0]
        } else if (index + 1 === 4) {
          this.textList[index].txt = prompts[1]
        } else if (index + 1 === 7) {
          this.textList[index].txt = prompts[2]
        }
      })
    },
    // 获取服务器Ip
    async getServierIp () {
      const res = await chatHelpIp()
      this.serIp = res.data.ip
    },
    // 校验手机号或邮箱
    validMobile (e) {
      const value = e.target.value
      if (this.activeIndex === 0) {
        this.mobileForm.mobileValid = ''
        this.mobileForm.mobile = value
      } else {
        this.emailForm.emailValid = ''
        this.emailForm.email = value
      }
    },
    // 发送验证码
    async sendCode () {
      const isMobile = this.activeIndex === 0
      if (isMobile) {
        if (!this.mobileForm.mobile) {
          this.mobileForm.mobileValid = '请输入手机号'
          return
        }
        const mobileReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (!mobileReg.test(this.mobileForm.mobile)) {
          this.mobileForm.mobileValid = '手机号格式不正确'
          return
        }
        this.mobileForm.isWait = true
        this.mobileForm.codeText = 59
        const mobileTimer = setInterval(() => {
          if (this.mobileForm.codeText === 0) {
            clearInterval(mobileTimer)
            this.mobileForm.isWait = false
            this.mobileForm.codeText = '重新发送'
            return
          }
          this.mobileForm.codeText--
        }, 1000)
      } else {
        if (!this.emailForm.email) {
          this.emailForm.emailValid = '请输入邮箱'
          return
        }
        const emailReg = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/
        if (!emailReg.test(this.emailForm.email)) {
          this.emailForm.emailValid = '邮箱格式不正确'
          return
        }
        this.emailForm.isWait = true
        this.emailForm.codeText = 59
        const emailTimer = setInterval(() => {
          if (this.emailForm.codeText === 0) {
            clearInterval(emailTimer)
            this.emailForm.isWait = false
            this.emailForm.codeText = '重新发送'
            return
          }
          this.emailForm.codeText--
        }, 1000)
      }
      try {
        const res = await chatCaptchaCode({
          account: isMobile ? this.mobileForm.mobile : this.emailForm.email,
          code_type: 2
        })
        if (res.code === 200) {
          this.$message({
            message: `验证码已发送至您的${isMobile ? '手机' : '邮箱'}，请接收`,
            type: 'success'
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 确认绑定手机号或邮箱
    async confirmBind () {
      // debugger
      const isMobile = this.activeIndex === 0
      if (isMobile) {
        if (!this.mobileForm.mobile) {
          this.mobileForm.mobileValid = '手机号不能为空'
          return
        }
        if (!this.mobileForm.code) {
          this.mobileForm.codeValid = '验证码不能为空'
          return
        }
      } else {
        if (!this.emailForm.email) {
          this.emailForm.emailValid = '邮箱不能为空'
          return
        }
        if (!this.emailForm.code) {
          this.emailForm.codeValid = '验证码不能为空'
          return
        }
      }
      try {
        const data = {}
        if (isMobile) {
          data.code = this.mobileForm.code
          data.mobile = this.mobileForm.mobile
        } else {
          data.code = this.emailForm.code
          data.email = this.emailForm.email
        }
        const res = await chatUserUpdateInfo(data)
        if (res.code === 200) {
          if (isMobile) {
            const userInfo = this.userInfo
            userInfo.mobile = this.mobileForm.mobile
            this.$store.commit('setUserInfo', userInfo)
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
            this.tipShow = true
          } else {
            this.$message({
              message: '邮箱绑定成功',
              type: 'success'
            })
            const userInfo = this.userInfo
            userInfo.email = this.emailForm.email
            this.$store.commit('setUserInfo', userInfo)
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
            this.bindShow = false
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 绑定dialog关闭时的回调
    bindBeforeClosed () {
      if (this.userInfo.mobile || this.userInfo.email) {
        const path = this.$route.path
        this.$router.replace(path)
        this.bindShow = false
      } else {
        this.confirmShow = true
      }
    },
    bindClosed () {
      if (this.userInfo.mobile || this.userInfo.email) {
        const path = this.$route.path
        this.$router.replace(path)
        this.bindShow = false
      }
    },
    // 提示去绑定邮箱
    tipConfirm () {
      this.tipShow = false
      this.activeIndex = 1
      this.mobileForm.mobile = ''
      this.mobileForm.mobileValid = ''
      this.mobileForm.code = ''
      this.mobileForm.codeValid = ''
    }
  },
  mounted () {
    if (this.action === 'bindMobile' && !this.userInfo.mobile && !this.userInfo.email) {
      this.bindShow = true
      this.activeIndex = 0
    }
    const timer = setInterval(() => {
      if (this.closeTime <= 0) {
        clearInterval(timer)
        return
      }
      this.closeTime--
    }, 1000)
  }
}
</script>

<style lang="less" scoped>
  @import url('./ask_answer.less');
</style>
